import React, { useEffect, useState } from 'react';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import { Button } from 'components/Button';
import Container from 'components/Container';
import ContainerHeader from 'components/ContainerHeader';
import Loading from 'components/Loading';
import { ApproveModal } from 'components/Modal';
import Text from 'components/Text';
import { TitleContainer } from 'pages/track/Contact/style';
import { useMembership } from 'shared/membershipContext';
import {
  useApproveMember,
  useUnApproveMember,
} from '../gql/useApproveMemberships';
import FormsRepeater from './Components/FormsRepeater';
import Membership from './Components/Membership';
import UserDetail from './Components/UserDetail';
import Waiver from './Components/Waiver';
import { useGetMember } from './gql/useGetMember';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
  grid-auto-rows: 100px;
  grid-template-areas:
    'a a b b c c d d'
    'a a b b c c d d';
  align-items: start;
  padding: 30px;

  @media (max-width: 768px) {
    display: flex;
    padding: 30px;
    flex-direction: column;
    align-items: center;
  }
`;

export const GridItem = styled.div`
  text-align: left;
  padding: 10px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const MemberDetail = () => {
  const { data, loading, refetch } = useGetMember();
  const history = useHistory();

  const { fetchMember, setFetchMember } = useMembership();

  useEffect(() => {
    if (fetchMember) {
      refetch();
      setFetchMember(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchMember]);

  const { pathname } = useLocation();

  const isMembership = !pathname.includes('registration');

  const userType = pathname?.split('/').includes('admin-track')
    ? 'track'
    : pathname?.split('/').includes('admin-employee')
    ? 'employee'
    : 'admin';

  const { id } = useParams();

  const [shouldDisplayApproveModal, setShouldDisplayApproveModal] =
    useState(false);
  const [unCheck, setUncheck] = useState(false);
  const approveMember = useApproveMember();
  const unApproveMember = useUnApproveMember();

  async function onConfirmApprove() {
    const result = unCheck
      ? await unApproveMember(Number(id))
      : await approveMember(Number(id));
    if (result) refetch();
    return result;
  }

  if (!data) return <Loading />;

  const transferMember = () => {
    const oldUser = data && data.getMember?.user;

    return history.push(
      userType === 'admin'
        ? `/admin/transferMembership/${id}?membership=${
            data.getMember?.membership?.name
          }&oldUserName=${
            data.getMember.user &&
            `${oldUser.last_name ? `${oldUser.last_name}, ` : ''}${
              oldUser.first_name
            } ${oldUser.middle_name ? oldUser.middle_name : ''} ${
              oldUser.suffix ? `, ${oldUser.suffix}` : ''
            }`
          }`
        : `/admin-${userType}/transferMembership/${id}?membership=${
            data.getMember?.membership?.name
          }&oldUserName=${
            data.getMember.user &&
            `${oldUser.last_name ? `${oldUser.last_name}, ` : ''}${
              oldUser.first_name
            } ${oldUser.middle_name ? oldUser.middle_name : ''} ${
              oldUser.suffix ? `, ${oldUser.suffix}` : ''
            }`
          }`
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Container>
      <ContainerHeader>
        <TitleContainer>
          <Text
            type="heading"
            color="#3C4144"
            inlineStyle={{ marginRight: 25 }}
          >
            {isMembership ? 'Member Detail' : 'Registration Detail'}
          </Text>
        </TitleContainer>
        {isMembership && userType === 'admin' ? (
          <div style={{ marginRight: 20 }}>
            <Button onClick={transferMember}>Transfer</Button>
          </div>
        ) : null}
        {isMembership && userType !== 'admin' ? (
          <div style={{ marginRight: 20 }}>
            <Button
              onClick={() => {
                setUncheck(!!data.getMember?.approved);
                setShouldDisplayApproveModal(true);
              }}
            >
              {data.getMember?.approved ? 'Unapprove' : 'Approve'} Membership
            </Button>
          </div>
        ) : null}
      </ContainerHeader>
      <Membership data={data.getMember} isMembership={isMembership} />

      <ContainerHeader>
        <TitleContainer>
          <Text
            type="heading"
            color="#3C4144"
            inlineStyle={{ marginRight: 25 }}
          >
            Pit Pay User Info
          </Text>
        </TitleContainer>
      </ContainerHeader>
      <UserDetail data={data.getMember.user} />

      {data.getMember.forms && data.getMember.forms.length ? (
        <ContainerHeader>
          <TitleContainer>
            <Text
              type="heading"
              color="#3C4144"
              inlineStyle={{ marginRight: 25 }}
            >
              Forms
            </Text>
          </TitleContainer>
        </ContainerHeader>
      ) : null}
      {data.getMember.forms && data.getMember.forms.length
        ? data.getMember.forms.map((form) => (
            <FormsRepeater formData={form} key={form.id} />
          ))
        : null}

      {data.getMember.waivers && data.getMember.waivers.length ? (
        <ContainerHeader>
          <TitleContainer>
            <Text
              type="heading"
              color="#3C4144"
              inlineStyle={{ marginRight: 25 }}
            >
              Agreements
            </Text>
          </TitleContainer>
        </ContainerHeader>
      ) : null}
      <Grid>
        {data.getMember.waivers && data.getMember.waivers.length
          ? data.getMember.waivers.map((waiver) => (
              <GridItem key={waiver.id}>
                <Waiver waiver={waiver} />
              </GridItem>
            ))
          : null}
      </Grid>
      <ApproveModal
        itemType="Member"
        isVisible={shouldDisplayApproveModal}
        onConfirm={onConfirmApprove}
        setIsVisible={setShouldDisplayApproveModal}
        unCheck={unCheck}
      />
    </Container>
  );
};

export default MemberDetail;
